import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

import { ActorFragmentDoc } from '../../../fragments.generated';

const defaultOptions = {} as const;
export type AvatarTagsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AvatarTagsQuery = {
  __typename?: 'Query';
  avatarTags: Array<{
    __typename?: 'AvatarTaggingAttribute';
    category: Types.AvatarTaggingAttributeCategoryEnum;
    attribute: string;
    internalTag: boolean;
  }>;
};

export type ActorsWithFiltersQueryVariables = Types.Exact<{
  inputs: Types.FilterAndSearchAvatarsInputs;
}>;

export type ActorsWithFiltersQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    actors: Array<{
      __typename?: 'Actor';
      id: number;
      name: string;
      image: string;
      preview: string;
      initials: string;
      accessLevel?: Types.ActorAccessLevel | null;
      availableIn?: Types.SubscriptionTier | null;
      isCustomActor?: boolean | null;
      isPartnerVoice?: boolean | null;
      isEnterprise?: boolean | null;
      isBusiness?: boolean | null;
      variants: Array<{
        __typename?: 'ActorVariant';
        id: number;
        version: string;
        isBeta?: boolean | null;
        isArchived?: boolean | null;
        locale: string;
        preview?: string | null;
        userSettings?: {
          __typename?: 'UserAvatarSettings';
          favoritedAt?: string | null;
        } | null;
        teamSettings?: {
          __typename?: 'TeamAvatarSettings';
          favoritedAt?: string | null;
        } | null;
        variantType: {
          __typename?: 'ActorVariantType';
          id: Types.ActorVariantTypeId;
          label: string;
          description?: string | null;
        };
        versions: {
          __typename?: 'ActorVariantVersions';
          previous?: {
            __typename?: 'TTSModelRelease';
            model: string;
            label: string;
            description?: string | null;
            overrideSpeakerVariantId?: number | null;
            features: Array<string>;
            studioProjectVersion?: Types.StudioProjectVersion | null;
          } | null;
          latest: {
            __typename?: 'TTSModelRelease';
            model: string;
            label: string;
            description?: string | null;
            overrideSpeakerVariantId?: number | null;
            features: Array<string>;
            studioProjectVersion?: Types.StudioProjectVersion | null;
          };
          next?: {
            __typename?: 'TTSModelRelease';
            model: string;
            label: string;
            description?: string | null;
            overrideSpeakerVariantId?: number | null;
            features: Array<string>;
            studioProjectVersion?: Types.StudioProjectVersion | null;
          } | null;
          preview?: {
            __typename?: 'TTSModelRelease';
            model: string;
            label: string;
            description?: string | null;
            overrideSpeakerVariantId?: number | null;
            features: Array<string>;
            studioProjectVersion?: Types.StudioProjectVersion | null;
          } | null;
        };
      }>;
    }>;
  };
};

export type PublicActorsWithFiltersQueryVariables = Types.Exact<{
  inputs?: Types.InputMaybe<Types.FilterAndSearchAvatarsInputs>;
}>;

export type PublicActorsWithFiltersQuery = {
  __typename?: 'Query';
  actors: Array<{
    __typename?: 'Actor';
    id: number;
    name: string;
    image: string;
    preview: string;
    initials: string;
    accessLevel?: Types.ActorAccessLevel | null;
    availableIn?: Types.SubscriptionTier | null;
    isCustomActor?: boolean | null;
    isPartnerVoice?: boolean | null;
    isEnterprise?: boolean | null;
    isBusiness?: boolean | null;
    variants: Array<{
      __typename?: 'ActorVariant';
      id: number;
      version: string;
      isBeta?: boolean | null;
      isArchived?: boolean | null;
      locale: string;
      preview?: string | null;
      userSettings?: {
        __typename?: 'UserAvatarSettings';
        favoritedAt?: string | null;
      } | null;
      teamSettings?: {
        __typename?: 'TeamAvatarSettings';
        favoritedAt?: string | null;
      } | null;
      variantType: {
        __typename?: 'ActorVariantType';
        id: Types.ActorVariantTypeId;
        label: string;
        description?: string | null;
      };
      versions: {
        __typename?: 'ActorVariantVersions';
        previous?: {
          __typename?: 'TTSModelRelease';
          model: string;
          label: string;
          description?: string | null;
          overrideSpeakerVariantId?: number | null;
          features: Array<string>;
          studioProjectVersion?: Types.StudioProjectVersion | null;
        } | null;
        latest: {
          __typename?: 'TTSModelRelease';
          model: string;
          label: string;
          description?: string | null;
          overrideSpeakerVariantId?: number | null;
          features: Array<string>;
          studioProjectVersion?: Types.StudioProjectVersion | null;
        };
        next?: {
          __typename?: 'TTSModelRelease';
          model: string;
          label: string;
          description?: string | null;
          overrideSpeakerVariantId?: number | null;
          features: Array<string>;
          studioProjectVersion?: Types.StudioProjectVersion | null;
        } | null;
        preview?: {
          __typename?: 'TTSModelRelease';
          model: string;
          label: string;
          description?: string | null;
          overrideSpeakerVariantId?: number | null;
          features: Array<string>;
          studioProjectVersion?: Types.StudioProjectVersion | null;
        } | null;
      };
    }>;
  }>;
};

export const AvatarTagsDocument = gql`
  query AvatarTags {
    avatarTags {
      category
      attribute
      internalTag
    }
  }
`;

/**
 * __useAvatarTagsQuery__
 *
 * To run a query within a React component, call `useAvatarTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvatarTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvatarTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvatarTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<AvatarTagsQuery, AvatarTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AvatarTagsQuery, AvatarTagsQueryVariables>(
    AvatarTagsDocument,
    options
  );
}
export function useAvatarTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AvatarTagsQuery, AvatarTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AvatarTagsQuery, AvatarTagsQueryVariables>(
    AvatarTagsDocument,
    options
  );
}
export type AvatarTagsQueryHookResult = ReturnType<typeof useAvatarTagsQuery>;
export type AvatarTagsLazyQueryHookResult = ReturnType<typeof useAvatarTagsLazyQuery>;
export type AvatarTagsQueryResult = Apollo.QueryResult<
  AvatarTagsQuery,
  AvatarTagsQueryVariables
>;
export const ActorsWithFiltersDocument = gql`
  query ActorsWithFilters($inputs: FilterAndSearchAvatarsInputs!) {
    user {
      id
      actors(inputs: $inputs) {
        ...ActorFragment
      }
    }
  }
  ${ActorFragmentDoc}
`;

/**
 * __useActorsWithFiltersQuery__
 *
 * To run a query within a React component, call `useActorsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActorsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActorsWithFiltersQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useActorsWithFiltersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActorsWithFiltersQuery,
    ActorsWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActorsWithFiltersQuery, ActorsWithFiltersQueryVariables>(
    ActorsWithFiltersDocument,
    options
  );
}
export function useActorsWithFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActorsWithFiltersQuery,
    ActorsWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActorsWithFiltersQuery, ActorsWithFiltersQueryVariables>(
    ActorsWithFiltersDocument,
    options
  );
}
export type ActorsWithFiltersQueryHookResult = ReturnType<
  typeof useActorsWithFiltersQuery
>;
export type ActorsWithFiltersLazyQueryHookResult = ReturnType<
  typeof useActorsWithFiltersLazyQuery
>;
export type ActorsWithFiltersQueryResult = Apollo.QueryResult<
  ActorsWithFiltersQuery,
  ActorsWithFiltersQueryVariables
>;
export const PublicActorsWithFiltersDocument = gql`
  query PublicActorsWithFilters($inputs: FilterAndSearchAvatarsInputs) {
    actors(inputs: $inputs) {
      ...ActorFragment
    }
  }
  ${ActorFragmentDoc}
`;

/**
 * __usePublicActorsWithFiltersQuery__
 *
 * To run a query within a React component, call `usePublicActorsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicActorsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicActorsWithFiltersQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function usePublicActorsWithFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PublicActorsWithFiltersQuery,
    PublicActorsWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PublicActorsWithFiltersQuery,
    PublicActorsWithFiltersQueryVariables
  >(PublicActorsWithFiltersDocument, options);
}
export function usePublicActorsWithFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicActorsWithFiltersQuery,
    PublicActorsWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PublicActorsWithFiltersQuery,
    PublicActorsWithFiltersQueryVariables
  >(PublicActorsWithFiltersDocument, options);
}
export type PublicActorsWithFiltersQueryHookResult = ReturnType<
  typeof usePublicActorsWithFiltersQuery
>;
export type PublicActorsWithFiltersLazyQueryHookResult = ReturnType<
  typeof usePublicActorsWithFiltersLazyQuery
>;
export type PublicActorsWithFiltersQueryResult = Apollo.QueryResult<
  PublicActorsWithFiltersQuery,
  PublicActorsWithFiltersQueryVariables
>;
